import React, { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Seo } from "@/components/Layout";
import { PageHeader, Breadcrumbs } from "@/components/Bits";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Loader2, Instagram } from "lucide-react";

export function Contact() {
  const [f, setF] = useState({ name: "", email: "", message: "" });
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setLoading(true);
    try { const { data } = await api.post("/contact", f); toast.success(data.message); setF({ name: "", email: "", message: "" }); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };
  const input = "w-full rounded-md border border-input bg-background px-3 py-2.5 text-sm";
  return (
    <>
      <Seo title="Contacto" description="Ponte en contacto con Hallo Suiza." />
      <PageHeader overline="Contacto" title="Escríbenos" subtitle="¿Tienes dudas, sugerencias o has detectado un error? Nos encantará leerte." />
      <div className="mx-auto max-w-2xl px-4 sm:px-6 lg:px-8 py-12">
        <Breadcrumbs items={[{ label: "Inicio", to: "/" }, { label: "Contacto" }]} />
        <form onSubmit={submit} className="space-y-4" data-testid="contact-form">
          <div><label className="block text-sm font-medium mb-1.5">Nombre</label><input required className={input} value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="contact-name" /></div>
          <div><label className="block text-sm font-medium mb-1.5">Correo</label><input required type="email" className={input} value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid="contact-email" /></div>
          <div><label className="block text-sm font-medium mb-1.5">Mensaje</label><textarea required rows={5} className={input} value={f.message} onChange={(e) => setF({ ...f, message: e.target.value })} data-testid="contact-message" /></div>
          <Button type="submit" disabled={loading} className="rounded-full" data-testid="contact-submit">{loading ? <Loader2 className="animate-spin" size={16} /> : "Enviar mensaje"}</Button>
        </form>
        <div className="mt-8 rounded-lg border border-border bg-card p-5 flex items-center gap-3">
          <Instagram size={20} className="text-primary" />
          <div><p className="font-medium text-sm">Síguenos en Instagram</p><a href="https://instagram.com/hallo.suiza" target="_blank" rel="noopener noreferrer" className="text-sm text-primary hover:underline">@hallo.suiza</a></div>
        </div>
      </div>
    </>
  );
}

export function FaqPage() {
  const [faq, setFaq] = useState([]);
  useEffect(() => { api.get("/faq").then(({ data }) => setFaq(data)); }, []);
  return (
    <>
      <Seo title="Preguntas frecuentes" description="Respuestas a las preguntas más habituales sobre Hallo Suiza." />
      <PageHeader overline="Preguntas frecuentes" title="Todo lo que necesitas saber" />
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8 py-12">
        <Breadcrumbs items={[{ label: "Inicio", to: "/" }, { label: "Preguntas frecuentes" }]} />
        <Accordion type="single" collapsible data-testid="faq-accordion">
          {faq.map((f, i) => (
            <AccordionItem key={i} value={`f${i}`}>
              <AccordionTrigger className="text-left font-display">{f.q}</AccordionTrigger>
              <AccordionContent className="text-muted-foreground leading-relaxed">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </>
  );
}
